import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FileUploadRequestBody, FileUploadResponse } from "./types";

export class FileUploadAPI extends BaseAPI<
  FileUploadRequestBody,
  FileUploadResponse
> {
  protected route = ApiRoutes.file.upload;
  protected method = RequestMethod.POST;
  protected hasFile = true;
}
